import { selectAuthenticationInfo } from '@src/selectors/user';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useCocoScript = () => {
  const authUser = useSelector(selectAuthenticationInfo);

  useEffect(() => {
    const COCO_MERCHANT_ID = 2157;
    const merchantId = authUser.employer.id;
    const head = document.querySelector('head');
    let script: HTMLElement;
    if (merchantId === COCO_MERCHANT_ID) {
      script = document.createElement('script');
      script.setAttribute('id', 'ze-snippet');
      script.setAttribute(
        'src',
        'https://static.zdassets.com/ekr/snippet.js?key=9a4d3ecf-ad01-4efa-9106-82716c4914f9'
      );

      if (head) head.appendChild(script);
    }
    return () => {
      if (head && script) head.removeChild(script);
    };
  }, [authUser]);
};

export default useCocoScript;
